{
    "notifications": {
        "Bildirimler": "Notifications",
        "Ara...": "Search...",
        "Hata oluştu": "Error occurred",
        "Admin": "Admin",
        "Tümünü Okunmadı Olarak İşaretle": "Mark all as unread",
        "Tümünü Okundu Olarak İşaretle": "Mark all as read",
        "Bildirim Bulunamadı!": "No Notifications Found!",
        "Tüm Bildirimleri Gör": "View All Notifications",
        "Tüm Bildirimler": "All Notifications",
        "Hiç bildiriminiz yok": "You have no notifications.",
        "Bildirim Gönder": "Send Notification",
        "Yönlendirilecek URL (Opsiyonel)": "Redirect URL (Optional)",
        "Mesaj": "Message",
        "Hedef Kitle": "Target Audience",
        "Herkese Gönder": "Send to All",
        "Belirli Kullanıcılara Gönder": "Send to Selected Users",
        "Kullanıcı Seçiniz": "Select User",
        "Başlık": "Title",
        "Gönder": "Send",
        "Okundu Olarak İşaretle": "Mark as Read",
        "Sil": "Delete",
        "Validation": {
            "required": "Required field"
        },
        "success": "Notification sent successfully.",
        "Bildirim Ayarları": "Notification Settings",
        "Tarayıcınız bildirimleri desteklemiyor": "Your browser does not support notifications.",
        "Bildirim izni reddedildi Tarayıcı ayarlarından izin verin": "Notification permission denied. Please allow in browser settings.",
        "Kayıtlı Cihazlar": "Registered Devices",
        "Yenile": "Refresh",
        "Cihaz Bilgisi": "Device Info",
        "Kayıt Tarihi": "Registration Date",
        "Son Erişim": "Last Access",
        "İşlem": "Action",
        "Bilinmeyen Cihaz": "Unknown Device",
        "Bu Cihaz": "This Device",
        "Kayıtlı cihaz bulunamadı": "No registered devices found.",
        "Ayarlar": "Settings",
        "Cihaz listesi alınamadı": "Could not fetch device list.",
        "Bu cihazın bildirim aboneliğini silmek istediğinize emin misiniz": "Are you sure you want to delete this device's subscription?",
        "Cihaz silindi": "Device deleted.",
        "Cihaz silinemedi": "Could not delete device.",
        "Bildirimleri Kapat": "Disable Notifications",
        "Bildirimleri Aç": "Enable Notifications",
        "Bildirim İzinleri": "Notification Permissions",
        "Bu cihazdan bildirim alıp almayacağınızı buradan yönetebilirsiniz": "You can manage whether to receive notifications from this device here."
    }
}
